import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const correspondenceAtom = atomWithStorage("correspondence", true);
export const deletedFilesAtom = atomWithStorage("deletedFiles", false);
export const fileLabelsAtom = atomWithStorage("fileLabels", true);
export const foldersVisibleAtom = atom<boolean>(false);
export const selectTagsAtom = atom<string>("");
